import { IconWrapper } from '../runtime';
export default IconWrapper('et-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'f39030ba' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5.25 9.1875C5.25 7.01288 7.01288 5.25 9.1875 5.25H17.25C17.6642 5.25 18 5.58579 18 6V6.75C18 7.16421 17.6642 7.5 17.25 7.5H9.1875C8.25552 7.5 7.5 8.25552 7.5 9.1875C7.5 10.1195 8.25552 10.875 9.1875 10.875H14.8125C16.9871 10.875 18.75 12.6379 18.75 14.8125C18.75 16.9871 16.9871 18.75 14.8125 18.75H6.75C6.33579 18.75 6 18.4142 6 18V17.25C6 16.8358 6.33579 16.5 6.75 16.5H14.8125C15.7445 16.5 16.5 15.7445 16.5 14.8125C16.5 13.8805 15.7445 13.125 14.8125 13.125H9.1875C7.01288 13.125 5.25 11.3621 5.25 9.1875Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'f39030ba',
      "x1": "7.51152e-08",
      "y1": "1.82812",
      "x2": "21.7969",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#15D14D"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#16A353"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#00AA4A"
    }
  })])])]);
});